(function (){
    'use strict';


    var extDeps = [];
    var module = angular.module('app.common.widgets.hacks',extDeps);




    module.directive('makeImagesResponsive', makeImagesResponsive);
    makeImagesResponsive.$inject=[];
    function makeImagesResponsive(){
        return{
            restrict:'A'
            , link: linkFn
        };

        function linkFn(scope, element){
            if(getInnerHtml(element).length ===0){
                var removeWatch = scope.$watch(function(){
                    if(getInnerHtml(element).length !==0){
                        prepareInnerImages(element);
                        removeWatch();
                    }
                });
            }

        }

        function getInnerHtml(element){
            return element.html().trim();
        }

        function prepareInnerImages(element){
            element.find('img').each(function(idx,el){
               var $el = $(el);
                $el.addClass('img-responsive')
                    .removeAttr('height width style');
            });
        }
    }



    /***
     * prevent ios scrolls from bouncing and not scolling
     * */
    module.directive('scrollWrapper',scrollWrapperDirective);
    scrollWrapperDirective.$inject=[];
    function scrollWrapperDirective(){
        return {
            restrict: 'C'
            , link: linkFn
            , scope: false
        };

        function linkFn(scope, element){

            // Check if we should allow scrolling up or down
            element.on("touchstart", touchStartHandler);
            element.on("touchmove", touchMoveHandler);
        }


        function touchMoveHandler(e) {
            if((/textarea/i).test(e.target.tagName))
                return;
            
            var event = e.originalEvent;
            var up = event.pageY > this.lastY;
            var down = !up;
            this.lastY = event.pageY;

            if ((up && this.allowUp) || (down && this.allowDown)) {
                event.stopPropagation();
            } else {
                event.preventDefault();
            }
        }

        function touchStartHandler (e) {
            // If the element is scrollable (content overflows), then...
            if (this.scrollHeight !== this.clientHeight) {
                // If we're at the top, scroll down one pixel to allow scrolling up
                if (this.scrollTop === 0) {
                    this.scrollTop = 1;
                }
                // If we're at the bottom, scroll up one pixel to allow scrolling down
                if (this.scrollTop === this.scrollHeight - this.clientHeight) {
                    this.scrollTop = this.scrollHeight - this.clientHeight - 1;
                }
            }
            // Check if we can scroll
            this.allowUp = this.scrollTop > 0;
            this.allowDown = this.scrollTop < (this.scrollHeight - this.clientHeight);
            this.lastY = e.originalEvent.pageY;
        }
    }

    /***
     * prevent some scoll isues in android
     */
    module.directive('rerouteCapturedScrollEvents',rerouteCapturedScrollEventsDirective);
    rerouteCapturedScrollEventsDirective.$inject=[];
    function rerouteCapturedScrollEventsDirective(){
        return{
            restrict:'A'
            , link: linkFn
        };

        function linkFn(scope,element){

            var isAndroid = /(android)/i.test(navigator.userAgent);
            if(isAndroid)
                $(element).on('scroll', function(){
                    if(element.scrollTop() === 0)
                        return;

                    $('.scroll-wrapper').not('.sidebar-nav').scrollTop(element.scrollTop());
                    element.scrollTop(0);
                });

        }
    }






})();

